import React, {useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import style from './style.module.css';
import Icons from '../Icons/Icons';
import { faSeedling } from '@fortawesome/free-solid-svg-icons';

import { urlScore, getLevels } from '../../utils/constants';

import useUserLevel from './../../hooks/useUserLevel';

const levels = getLevels()

interface LevelProps {
    click?: any;
}

const Level: React.FC<LevelProps> = ({click = () => {} }) => {

    const [levelIcon,setLevelIcon] = useState(faSeedling);
    const [levelStyle,setLevelStyle] = useState(style.firstTier);
    const [shimmer,setShimmer] = useState(false)

    const levelNumber = useUserLevel();
    const navigate = useNavigate();

    useEffect(() => {
        const tier = levels.find(({ max }) => levelNumber < max);
        if (tier) {
            setShimmer(tier.max === 90 || tier.max === 100 || tier.max === Infinity);
            setLevelIcon(tier.icon);
            setLevelStyle(tier.style);
        }
    }, [levelNumber]);

    const handleGoToScore = () => {
        click();
        navigate(urlScore);
    }

    return (<>
        <div className={`${style.level} ${levelStyle} ${shimmer ? style.shimmer : ''}`} onClick={handleGoToScore}>
            <Icons icon={levelIcon} /><span>{levelNumber}</span>
        </div>
    </>)
}


export default Level;